export default "__VITE_ASSET__DQDT3Hvi__"